var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useEffect, useMemo, useState } from "react";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import di from "@mainDi/features/webHome/index";
import { InView } from "react-intersection-observer";
import _ from "underscore";
import Loader from "./Loader";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
var timeout;
var prevCall;
var disableMemoization = false;
export var inViewFunc = function (inView, ele, inViewCallBack, setInviewData, inViewData, sectionName, // when two callback on same screen
index) {
    if (inViewCallBack) {
        if (sectionName) {
            if (sectionName == prevCall) {
                clearTimeout(timeout);
            }
            else {
            }
        }
        else {
            clearTimeout(timeout);
        }
        setInviewData(function (_list) {
            var index = _list === null || _list === void 0 ? void 0 : _list.findIndex(function (x) { return x === ele[inViewCallBack === null || inViewCallBack === void 0 ? void 0 : inViewCallBack.key]; });
            if (inView && index === -1) {
                _list === null || _list === void 0 ? void 0 : _list.push(ele[inViewCallBack === null || inViewCallBack === void 0 ? void 0 : inViewCallBack.key]);
            }
            else {
                if (!inView && index > -1) {
                    _list === null || _list === void 0 ? void 0 : _list.splice(index, 1);
                }
            }
            return _list;
        });
        timeout = setTimeout(function () {
            inViewCallBack.callback(inViewData);
            //prevCall
        }, 100);
        prevCall = sectionName;
    }
};
var trAreEqual = function (prevProps, nextProps) {
    if (disableMemoization == true) {
        return false;
    }
    return (_.isEqual(prevProps.columns, nextProps.columns) &&
        (prevProps.tableData[nextProps.keys]
            ? _.isEqual(prevProps.tableData[nextProps.keys], nextProps.ele)
            : false));
};
var TrMemoComponent = memo(function (props) {
    return (React.createElement(InView, { as: "tr", onChange: function (inView) {
            if (props.inViewCallBack)
                inViewFunc(inView, props.ele, props.inViewCallBack, props.setInviewData, props.inViewData, props.sectionName);
        }, threshold: 0.5, delay: 1000, 
        // fallbackInView={true}
        trackVisibility: true, className: (props === null || props === void 0 ? void 0 : props.rowClassName)
            ? typeof (props === null || props === void 0 ? void 0 : props.rowClassName) === "string"
                ? props === null || props === void 0 ? void 0 : props.rowClassName
                : props === null || props === void 0 ? void 0 : props.rowClassName(props.ele)
            : "", 
        // key={idx}
        onClick: function () { return props.rowOnClick && props.rowOnClick(props.ele); } }, props.columns &&
        props.columns.length > 0 &&
        props.columns.map(function (cell, index) {
            return (React.createElement(TdMemoComponent, { cell: cell, ele: props.ele, keys: index, tableData: props.tableData, applyColumnSepartor: props.applyColumnSepartor, columnSepartorNumer: props.columnSepartorNumer, trCustomFunctionOnClickoftd: cell.trCustomFunctionOnClickoftd, trCustomFunction: cell.trCustomFunction, rowIndex: props.keys }));
        })));
}, trAreEqual);
var tdAreEqual = function (prevProps, nextProps) {
    if (disableMemoization == true) {
        return false;
    }
    // return _.isEqual(
    //   prevProps.tableData[nextProps.keys] &&
    //     prevProps.tableData[nextProps.keys][nextProps.cell.key],
    //   nextProps.ele[nextProps.cell.key]
    // );
    if (prevProps.cell.keysForCustomFunction) {
        return prevProps.cell.keysForCustomFunction
            .map(function (ele) {
            return (prevProps.ele[nextProps.cell[ele]] &&
                _.isEqual(prevProps.ele[nextProps.cell[ele]], nextProps.ele[nextProps.cell[ele]]));
        })
            .some(function (x) { return x === false; });
    }
    else if (prevProps.ele[nextProps.cell.key2]) {
        return (_.isEqual(prevProps.ele[nextProps.cell.key] && prevProps.ele[nextProps.cell.key], nextProps.ele[nextProps.cell.key]) &&
            _.isEqual(prevProps.ele[nextProps.cell.key2] &&
                prevProps.ele[nextProps.cell.key2], nextProps.ele[nextProps.cell.key2]));
    }
    else if (prevProps.ele[nextProps.cell.key3]) {
        return (_.isEqual(prevProps.ele[nextProps.cell.key] && prevProps.ele[nextProps.cell.key], nextProps.ele[nextProps.cell.key]) &&
            _.isEqual(prevProps.ele[nextProps.cell.key2] &&
                prevProps.ele[nextProps.cell.key2], nextProps.ele[nextProps.cell.key2]) &&
            _.isEqual(prevProps.ele[nextProps.cell.key3] &&
                prevProps.ele[nextProps.cell.key3], nextProps.ele[nextProps.cell.key3]));
    }
    else if (prevProps.cell.trCustomFunction) {
        return _.isEqual(prevProps.cell.trCustomFunction, nextProps.cell.trCustomFunction);
    }
    else {
        return _.isEqual(prevProps.ele[nextProps.cell.tdCustomFunction] &&
            prevProps.ele[nextProps.cell.key || nextProps.cell.sortKey] &&
            prevProps.ele[nextProps.cell.key || nextProps.cell.sortKey], nextProps.ele[nextProps.cell.key || nextProps.cell.sortKey]);
    }
};
var TdMemoComponent = memo(function (props) {
    var _a, _b, _c, _d, _e, _f;
    return (React.createElement("td", { key: props.keys, className: props.cell.columnClassName, style: props.applyColumnSepartor && props.columnSepartorNumer === props.keys
            ? { borderRight: "1px solid  #E7E7E7" }
            : {}, onClick: function (e) {
            var _a;
            ((_a = props.cell) === null || _a === void 0 ? void 0 : _a.trCustomFunctionOnClickoftd) &&
                props.cell.trCustomFunctionOnClickoftd(e, props.ele);
        } },
        ((_a = props.cell) === null || _a === void 0 ? void 0 : _a.tdCustomFunction) && !props.cell.keysForCustomFunction
            ? (_b = props.cell) === null || _b === void 0 ? void 0 : _b.tdCustomFunction(props.ele["".concat(props.cell.key)], props.cell.key2 ? props.ele["".concat(props.cell.key2)] : null, props.cell.key3 ? props.ele["".concat(props.cell.key3)] : null, (_c = props === null || props === void 0 ? void 0 : props.rowIndex) !== null && _c !== void 0 ? _c : null)
            : props.ele["".concat(props.cell.key)],
        ((_d = props.cell) === null || _d === void 0 ? void 0 : _d.tdCustomFunction) &&
            props.cell.keysForCustomFunction &&
            ((_e = props.cell) === null || _e === void 0 ? void 0 : _e.tdCustomFunction(props.cell.keysForCustomFunction.map(function (keyName) { return props.ele[keyName]; }), (_f = props === null || props === void 0 ? void 0 : props.rowIndex) !== null && _f !== void 0 ? _f : null)),
        props.cell.trCustomFunction && props.cell.trCustomFunction(props.ele)));
}, tdAreEqual);
var thAreEqual = function (prevProps, nextProps) {
    return _.isEqual(prevProps, nextProps);
};
var ThMemoComponent = memo(function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var isSelectedColumn = ((_a = props === null || props === void 0 ? void 0 : props.sortingKey) === null || _a === void 0 ? void 0 : _a.key) === props.tableHead.key ||
        ((_b = props === null || props === void 0 ? void 0 : props.sortingKey) === null || _b === void 0 ? void 0 : _b.key) === ((_c = props.tableHead) === null || _c === void 0 ? void 0 : _c.sortKey);
    return (React.createElement("th", { key: props.idx, className: props.tableHead.columnClassName ? props.tableHead.columnClassName : "", onMouseEnter: function () {
            return props.handleHover(props.tableHead, props.idx, "ENTER");
        }, onMouseLeave: function () { return props.handleHover(props.tableHead, props.idx, "EXIT"); }, style: props.applyColumnSepartor && props.columnSepartorNumer === props.idx
            ? { borderRight: "1px solid  #E7E7E7" }
            : {}, id: (_d = props.tableHead) === null || _d === void 0 ? void 0 : _d.thId }, props.tableHead.arrows ? (React.createElement("div", { className: "title" },
        React.createElement("div", { className: "d-flex align-items-center gap-2 ".concat(props.tableHead.onlyOneArrowAtaTime &&
                props.sortingAppliedForColoumn[props.idx]
                ? "DMSansMedium_12_500 txt-midnight-blue"
                : "", " ").concat(props.tableHead.arrowClassName
                ? props.tableHead.arrowClassName
                : "") },
            React.createElement("label", null, props.tableHead.columnName),
            React.createElement("div", { className: "arrows", onClick: function () {
                    var _a;
                    if (props.tableHead.applySorting) {
                        if (!(props === null || props === void 0 ? void 0 : props.callbackSorted)) {
                            props === null || props === void 0 ? void 0 : props.setSortingType(function (prevState) {
                                return !prevState;
                            });
                            props === null || props === void 0 ? void 0 : props.setSortingKey({
                                key: props.tableHead.key
                                    ? props.tableHead.key
                                    : (_a = props.tableHead) === null || _a === void 0 ? void 0 : _a.sortKey,
                                type: props.tableHead.type,
                            });
                            props.setSortingAppliedForColoumn(function (prevState) {
                                return prevState.map(function (x, id) {
                                    if (props.idx === id)
                                        x = true;
                                    else
                                        x = false;
                                    return x;
                                });
                            });
                        }
                        else {
                            props === null || props === void 0 ? void 0 : props.callbackSorted(__assign(__assign({}, props.tableHead), { type: !props.sortingType }));
                        }
                        if (props.tableHead.onlyOneArrowAtaTime ||
                            props.tableHead.onlyOneArrowAtaTimeWithCaretIcon) {
                            props.setSortingAppliedForColoumn(function (prevState) {
                                return prevState.map(function (x, id) {
                                    if (props.idx === id)
                                        x = true;
                                    else
                                        x = false;
                                    return x;
                                });
                            });
                            props.setUparrow(function (prevState) {
                                return prevState.map(function (x, id) {
                                    if (id === props.idx)
                                        x = !x;
                                    return x;
                                });
                            });
                        }
                    }
                    else {
                        null;
                    }
                }, style: props.applyColumnSepartor &&
                    props.columnSepartorNumer === props.idx
                    ? { borderRight: "1px solid  #E7E7E7" }
                    : {} }, props.tableHead.onlyOneArrowAtaTime ? (React.createElement("div", { className: "arrow-at-a-time ".concat(props.hoveredOn[props.idx] ||
                    props.sortingAppliedForColoumn[props.idx]
                    ? "visible"
                    : "invisible", " ") },
                props.upArrow[props.idx] && (React.createElement("i", { className: (_e = props.sortIconDown) !== null && _e !== void 0 ? _e : "edel-icon-caret-down" })),
                !props.upArrow[props.idx] && (React.createElement("i", { className: " ".concat((_f = props.sortIconDown) !== null && _f !== void 0 ? _f : "edel-icon-caret-down", " down") })))) : props.tableHead.onlyOneArrowAtaTimeWithCaretIcon &&
                props.sortingAppliedForColoumn[props.idx] ? (React.createElement("div", { className: "arrow-at-a-time " },
                props.upArrow[props.idx] && (React.createElement("i", { className: (_g = props.sortIconUp) !== null && _g !== void 0 ? _g : "edel-icon-caret-up" })),
                !props.upArrow[props.idx] && (React.createElement("i", { className: (_h = props.sortIconDown) !== null && _h !== void 0 ? _h : "edel-icon-caret-down" })))) : (props === null || props === void 0 ? void 0 : props.callbackSorted) ? (React.createElement(React.Fragment, null,
                React.createElement("i", { className: (_j = props.sortIconUp) !== null && _j !== void 0 ? _j : "edel-icon-caret-up", style: isSelectedColumn && !props.sortingType
                        ? {
                            color: (props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor)
                                ? props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor
                                : "#444444",
                        }
                        : {} }),
                React.createElement("i", { className: (_k = props.sortIconDown) !== null && _k !== void 0 ? _k : "edel-icon-caret-down", style: isSelectedColumn && props.sortingType
                        ? {
                            color: (props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor)
                                ? props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor
                                : "#444444",
                        }
                        : {} }))) : (React.createElement(React.Fragment, null,
                React.createElement("i", { className: (_l = props.sortIconUp) !== null && _l !== void 0 ? _l : "edel-icon-caret-up", style: props.sortingAppliedForColoumn[props.idx] &&
                        !props.sortingType
                        ? {
                            color: (props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor)
                                ? props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor
                                : "#444444",
                        }
                        : {} }),
                React.createElement("i", { className: (_m = props.sortIconDown) !== null && _m !== void 0 ? _m : "edel-icon-caret-down", style: props.sortingAppliedForColoumn[props.idx] &&
                        props.sortingType
                        ? {
                            color: (props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor)
                                ? props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor
                                : "#444444",
                        }
                        : {} }))))))) : (React.createElement("label", null, props.tableHead.columnName))));
}, thAreEqual);
var GenericTable = function (props) {
    var _a, _b;
    // const [tableData, setTableData] = useState<any>([]);
    var _c = props.numberOfDataItemsToShow, numberOfDataItemsToShow = _c === void 0 ? (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.length : _c;
    var _d = __read(useState(false), 2), sortingType = _d[0], setSortingType = _d[1];
    var _e = __read(useState(undefined), 2), sortingKey = _e[0], setSortingKey = _e[1];
    // const [dataType, setDataType] = useState<string>();
    var _f = __read(useState([]), 2), inViewData = _f[0], setInviewData = _f[1];
    var _g = __read(useState(new Array(props.columns.length).fill(false)), 2), sortingAppliedForColoumn = _g[0], setSortingAppliedForColoumn = _g[1];
    var _h = __read(useState(new Array(props.columns.length).fill(false)), 2), hoveredOn = _h[0], setHoveredOn = _h[1];
    var _j = __read(useState(new Array(props.columns.length).fill(false)), 2), upArrow = _j[0], setUparrow = _j[1];
    var sortedData = useMemo(function () {
        var _a;
        return ((props === null || props === void 0 ? void 0 : props.data) &&
            !(props === null || props === void 0 ? void 0 : props.callbackSorted) &&
            ((_a = di === null || di === void 0 ? void 0 : di.common) === null || _a === void 0 ? void 0 : _a.getSortedData(props === null || props === void 0 ? void 0 : props.data, sortingType, sortingKey === null || sortingKey === void 0 ? void 0 : sortingKey.key, sortingKey === null || sortingKey === void 0 ? void 0 : sortingKey.type)));
    }, [sortingKey, props === null || props === void 0 ? void 0 : props.data]);
    useEffect(function () {
        var _a, _b;
        if (props.selectedSortColumnVal) {
            var sortingColumnIndex_1 = (_a = props === null || props === void 0 ? void 0 : props.columns) === null || _a === void 0 ? void 0 : _a.findIndex(function (item) {
                return (item === null || item === void 0 ? void 0 : item.sortKey) === (props === null || props === void 0 ? void 0 : props.selectedSortColumnVal) ||
                    (item === null || item === void 0 ? void 0 : item.key) === (props === null || props === void 0 ? void 0 : props.selectedSortColumnVal);
            });
            setSortingType(props.selectedSortVal == ESortOrder.ASCENDING ? true : false);
            setSortingKey({
                key: props.selectedSortColumnVal,
                type: sortingColumnIndex_1 !== -1
                    ? props === null || props === void 0 ? void 0 : props.columns[sortingColumnIndex_1].type
                    : (_b = props === null || props === void 0 ? void 0 : props.selectedDefaultSortType) !== null && _b !== void 0 ? _b : null,
            });
            setSortingAppliedForColoumn(function (prevState) {
                var localState = __spreadArray([], __read(prevState), false);
                if (sortingColumnIndex_1 !== -1) {
                    localState[sortingColumnIndex_1] = true;
                }
                return localState;
            });
        }
        else {
            setSortingKey(undefined);
            setSortingType(false);
        }
    }, [props.selectedSortColumnVal, props.selectedSortVal]);
    if (props.disableMemoization === true) {
        disableMemoization = true;
    }
    var handleHover = function (tableHead, idx, enterOrExit) {
        if (tableHead.applySorting)
            switch (enterOrExit) {
                case "ENTER":
                    setHoveredOn(function (prevState) {
                        return prevState.map(function (x, id) {
                            if (id === idx)
                                x = true;
                            else
                                x = false;
                            return x;
                        });
                    });
                    break;
                case "EXIT":
                    setHoveredOn(function (prevState) {
                        return prevState.map(function (x, id) {
                            if (id === idx && !upArrow[id])
                                x = false;
                            if (id === idx && upArrow[id])
                                x = true;
                            return x;
                        });
                    });
                    break;
            }
    };
    return props.loader ? (props.shimmer ? (props.shimmer) : (React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "generic-table ".concat(props.parentClassName ? props.parentClassName : "") },
            React.createElement("table", { className: props.tableClassName ? props.tableClassName : "", ref: props === null || props === void 0 ? void 0 : props.tableRef },
                React.createElement("thead", null, props === null || props === void 0 ? void 0 :
                    props.extraHeader,
                    React.createElement("tr", { className: props.hideHeader ? "d-none" : "" }, props.columns &&
                        props.columns.map(function (tableHead, idx) {
                            return (React.createElement(ThMemoComponent, { tableHead: tableHead, idx: idx, callbackSorted: props.callbackSorted, 
                                // applySortingAccordingKey={applySortingAccordingKey}
                                setSortingKey: setSortingKey, columns: props.columns, setSortingType: setSortingType, applyColumnSepartor: props.applyColumnSepartor, columnSepartorNumer: props.columnSepartorNumer, handleHover: handleHover, sortingAppliedForColoumn: sortingAppliedForColoumn, hoveredOn: hoveredOn, upArrow: upArrow, setSortingAppliedForColoumn: setSortingAppliedForColoumn, setUparrow: setUparrow, sortingType: sortingType, sortingKey: sortingKey, sortIconUp: props.sortIconUp, sortIconDown: props.sortIconDown, sortArrowHighlightingColor: props === null || props === void 0 ? void 0 : props.sortArrowHighlightingColor }));
                        }))), props === null || props === void 0 ? void 0 :
                props.titleBeforeTr,
                React.createElement("tbody", null,
                    (props === null || props === void 0 ? void 0 : props.data) &&
                        (props === null || props === void 0 ? void 0 : props.data.length) > 0 &&
                        (sortingKey && sortedData
                            ? sortedData === null || sortedData === void 0 ? void 0 : sortedData.map(function (ele, idx) {
                                if (idx < numberOfDataItemsToShow)
                                    return (React.createElement(React.Fragment, null,
                                        React.createElement(TrMemoComponent, { ele: ele, tableData: sortedData, inViewCallBack: props.inViewCallBack, setInviewData: setInviewData, inViewData: inViewData, rowClassName: props.rowClassName, key: idx, columns: props.columns, keys: idx, rowOnClick: props.rowOnClick, sectionName: props.sectionName, applyColumnSepartor: props.applyColumnSepartor, columnSepartorNumer: props.columnSepartorNumer })));
                            })
                            : ((_b = props.columns) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                                (props === null || props === void 0 ? void 0 : props.data.map(function (ele, idx) {
                                    if (idx < numberOfDataItemsToShow)
                                        return (React.createElement(React.Fragment, null,
                                            React.createElement(TrMemoComponent, { ele: ele, tableData: props === null || props === void 0 ? void 0 : props.data, inViewCallBack: props.inViewCallBack, setInviewData: setInviewData, inViewData: inViewData, rowClassName: props.rowClassName, key: idx, columns: props.columns, keys: idx, rowOnClick: props.rowOnClick, sectionName: props.sectionName, applyColumnSepartor: props.applyColumnSepartor, columnSepartorNumer: props.columnSepartorNumer })));
                                }))),
                    props.message && props.message.show && (React.createElement("tr", null,
                        React.createElement("td", { colSpan: 30, className: props.messageShowClass && "messageShowClass" },
                            React.createElement(Errormsg, { customMsg: props.customMsg, icon: props.message.icon, msg: props.message.msg, paths: props.paths })))))))));
};
export default GenericTable;
